import Table from 'src/MarketDataComponents/Table';
import Sparkline from 'src/MarketDataComponents/Sparkline';

const includeTrendlines = true;

const defaultTableClassName = 'data-table data-table--small data-table--scroll highlight margin-0 data-table--table-layout-fixed';
const alignRightClassName = '';

export default function SummaryTable({periods, categories}) {

    const getSparklineProps = (category) => {
        const sparklineData = [];
        periods.map((period) => {
            sparklineData.push({
                label: period.label,
                value: parseFloat(period.values[category]?.replace(/[^0-9\.\-]/g, ''))
            });
        });
        return {
            chartData: sparklineData,
            tooltipHeader: categories[category]
        };
    };

    const getTable = () => {
		return <Table
            defaultClassName={defaultTableClassName}
            theadRows={[
                <tr key="headrow">
                    <th></th>
                    {periods.map((period, i) => {
                        return (
                            <th key={i} className={alignRightClassName}>
                                {period.label}
                            </th>
                        );
                    })}
                    {includeTrendlines &&
                    <th className={alignRightClassName}>Trend</th>
                    }
                </tr>
            ]}
            tbodyRows={
                Object.keys(categories).map((category, i) => {
                    return (
                        <tr key={i}>
                            <td scope="row" data-testid={`${((categories[category]).replace(/\s/g,'')).toLowerCase()}Label`}>
                                {categories[category]}
                            </td>
                            {periods.map( (period, j) => {
                                return (
                                    <td key={j} aria-label={period.label} className={alignRightClassName} data-testid={`${((categories[category]).replace(/\s/g,'')).toLowerCase()}Value${j}`}>
                                        {period.values[category] ?? '-'}
                                    </td>
                                );
                            })}
                            {includeTrendlines &&
                            <td className={`${alignRightClassName} ajb-sparkline-chart-cell`} data-testid="summaryTableTrendChart">
                                <Sparkline {...getSparklineProps(category)} />
                            </td>
                            }
                        </tr>
                    );
                })
            }
		/>
	};

    return getTable();

}